module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"prices":"Тарифы","calculator":"Калькулятор","signUp":"Начать работу с Huntica"}}')
  delete Component.options._Ctor
}
